class VwTestDetaybilgiDTO {
    id: number = null;
    testId?: number = null;
    aciklama?: string = "";
    aktif?: string = "E";
    veritip?: number = null;
    zorunlu?: string = "H";
    sira?: number = null;
    veri?: string = "";
    lishesap?: string = "";
    minimumdeger?: number = null;
    maksimumdeger?: number = null;
    cinsiyet?: number = null;
    yasBaslangic?: number = null;
    yasBitis?: number = null;
}
export default VwTestDetaybilgiDTO;